import React, { useState } from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import Tabs from 'ui/Tabs/Tabs';
import MobileSubtitle from 'ui/MobileSubtitle/MobileSubtitle';
import SinglePrepaidBen from './subtabs/SinglePrepaidBen/SinglePrepaidBen';
import BulkPrepaidBen from './subtabs/BulkPrepaidBen/BulkPrepaidBen';

const tabsOptions = [{ label: 'Single Beneficiaries' }, { label: 'Bulk Beneficiaries' }];

const PrepaidCardBen = () => {
  const [activeSubTab, setActiveSubTab] = useState<false | number>(0);

  const downMdScreen = useMediaQuery(useTheme().breakpoints.down('sm'));

  const handleOnChangeTab = (_event: React.ChangeEvent<unknown>, tabIndex: number) => {
    setActiveSubTab(tabIndex);
  };

  return (
    <>
      {downMdScreen && <MobileSubtitle>Select category</MobileSubtitle>}
      <Tabs
        value={activeSubTab}
        options={tabsOptions}
        onChange={handleOnChangeTab}
        theme={downMdScreen ? 'primary' : 'secondary'}
        disableVertical
        scrollButtons="auto"
      />
      {activeSubTab === 0 && <SinglePrepaidBen />}
      {activeSubTab === 1 && <BulkPrepaidBen />}
    </>
  );
};

export default PrepaidCardBen;
